import React, {
  createContext, useContext, useMemo, useState,
} from 'react';

interface PageMetadata {
  title: string;
  project_id?: string;
  avatar_url?: string;
}

interface PageMetadataContextProps {
  metadata: PageMetadata;
  setMetadata: (metadata: PageMetadata) => void;
}

const PageMetadataContext = createContext<PageMetadataContextProps | undefined>(undefined);

export const usePageMetadata = () => {
  const context = useContext(PageMetadataContext);
  if (!context) {
    throw new Error('usePageMetadata must be used within a PageMetadataProvider');
  }
  return context;
};

export const PageMetadataProvider = ({ children }: { children: React.ReactNode }) => {
  const [metadata, setMetadata] = useState<PageMetadata>({ title: 'MPG HQ' });

  // Memoize the context value to avoid unnecessary re-renders
  const value = useMemo(() => ({ metadata, setMetadata }), [metadata, setMetadata]);

  return (
    <PageMetadataContext.Provider value={value}>
      {children}
    </PageMetadataContext.Provider>
  );
};
